import { ScheduleService } from '@/openapi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/util/queryKeys';

export const usePublishDateQuery = (periodMonthYear: Date) => {
  const periodYear = periodMonthYear.getFullYear();
  const periodMonth = periodMonthYear.getMonth() + 1;
  return useQuery({
    queryKey: queryKeys.schedule.publishDate(periodYear, periodMonth),
    queryFn: () =>
      ScheduleService.scheduleServiceGetPublishDate({
        query: {
          year: periodYear,
          month: periodMonth,
        },
      }),
  });
};
